
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `انقر على «فتح في متصفح…»`,
's182ab2d6c997515f': `أضفه إلى شاشتك الرئيسية للحصول على تجربة شاملة ووصول سهل.`,
's224cbcec014ef6b5': `اضغط على مشاركة في الشريط العلوي`,
's233af3b7eb5e0364': `إضافة إلى الصفحة الرئيسية`,
's37a9e8aec5713460': `المزيد`,
's4c3161035f3a1413': `اضغط على القائمة`,
's4e1e10a6ca408245': `انقر على "إضافة إلى الشاشة الرئيسية"`,
's6196153c4b0c1ea0': `تثبيت`,
's633502f7cff4f847': `افتح قائمة المتصفح`,
's681e399d63311fba': `عرض الصور`,
's6d14a4f70ba4e3cf': `اضغط على القائمة إذا لم يكن هناك رمز مشاركة`,
's922329d6f6213590': `إضافة إلى القوائم`,
's9c63a79ffcc2a3a3': `اضغط على "إضافة إلى الشاشة الرئيسية"`,
'sa2d71bfd9525168d': `اضغط على "إضافة إلى Dock"`,
'sa5ef80b4bb9b39f8': `أقل`,
'sb527eca1c1d7e7be': `افتح قائمة المتصفح داخل التطبيق`,
'sba52286c21552a4e': `ثبّته على جهازك للحصول على تجربة شاملة ووصول سهل.`,
'sc16e00a7a8b2fde2': `رجوع`,
'scdaf4bbff76674c8': `إضافة إلى الشاشة الرئيسية`,
'sd18a5b85f599ff3c': `افتح الرابط المنسوخ في Safari`,
'se72fc3a84f9b51c3': `اضغط لنسخ الرابط`,
'se740f75b95a51807': `أضفه إلى شريط القوائم للحصول على تجربة شاملة ووصول سهل.`,
'sfa6c42cdf48d93d2': `لكن هذا المتصفح لا يدعم ذلك. افتح الرابط في متصفح خارجي للمتابعة.`,
'sfb78526365796a41': `اضغط على "عرض المزيد" في قائمة المشاركة`,
'sfea652f6580ff086': `يتمتع هذا الموقع بوظائف التطبيق.`,
    };
  